import NavigateItem from './navigateItem';
import React, { Component, ReactNode, PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import { classSet } from '@umu/umu-dom';

import './navigate.scss';

export enum STYLE {
    YELLOW = 1,
    BLUE = 2,
    BLACK = 3,
}

export enum TYPE {
    'flex' = 1, // 每个元素平分
    'crowded' = 2, // 一个挨一个
}

interface IProps extends PropsWithChildren<{}> {
    cls: string;
    replace?: boolean;
    style?: STYLE;
    type?: TYPE;
}

const STYLES = {
    [STYLE.YELLOW]: 'yellow',
    [STYLE.BLUE]: 'blue',
    [STYLE.BLACK]: 'black',
};

export default class Navigate extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public renderChildren() {
        const childrenArray: ReactNode[] = [];
        React.Children.forEach(this.props.children, (child: ReactNode, index: number) => {
            if (!child) {
                return;
            }
            const clone: React.ReactElement<NavigateItem> = React.cloneElement(child as JSX.Element, {
                key: `visible-${index}`,
            });
            const item = child as unknown as NavigateItem;
            const to: string = item.props.to;
            const className = classSet({
                'header-item': true,
                [`${STYLES[this.props.style || STYLE.YELLOW]} ${'item-' + index}`]: true,
            });
            childrenArray.push(
                <li className={className} key={`nav-item-${index}`}>
                    <NavLink className="tab-title" exact to={to} activeClassName="active" replace={this.props.replace}>
                        {clone}
                        <div className="active-border" />
                    </NavLink>
                </li>,
            );
        });
        return childrenArray;
    }

    public render() {
        return (
            <div className={`nav-tabs ${this.props.cls}`}>
                <ul className={`tab-header ${TYPE[this.props.type || 1]}`}>{this.renderChildren()}</ul>
            </div>
        );
    }
}
